import { Fragment } from "react";
import styled from "styled-components";

// ** Custom Components
import Selector from "components/layout/Selector/Selector";
import Button from "components/base/Button";
import Text from "components/typography/Text";
import Block from "components/layout/Block";

// #####################################################

const StyledText = styled(Text)`
	line-height: 1.5;
`;

const Activator = ({
	activatorStyle,
	activatorOptions,
	activatorWrapperStyle,
	innerRef,
	label,
	onClick,
	isOpen,
	isPhone,
	displayContent,
	isSelected,
	selectedLimitText,
	selectedLimit,
	disabled,
	customWidth,
	layerSide = "bottom",
	withCaret = true,
	customCaretMargin,
}) => {
	const {
		noPad,
		noBold,
		boldOnEmpty,
		noTopMargin,
		noBottomMargin = false,
		flex1 = true,
		hideLabel = false,
		isLanding = false,
		noMinWidth = false,
		isMultiple = false,
	} = activatorOptions || {};

	// #####################################################

	return (
		<Selector
			title={!hideLabel && label}
			noPad={noPad}
			noBold={noBold}
			noTopMargin={noTopMargin}
			noBottomMargin={noBottomMargin}
			noMinWidth={noMinWidth}
			flex1={flex1}
			isOpen={isOpen}
			layerSide={layerSide}
			innerRef={innerRef}
			style={activatorWrapperStyle}
		>
			<Selector.Section
				as={Button}
				label={label}
				onClick={(e) => {
					const element = e.target.closest(
						'[idattribute="removeSelected"]'
					);
					if (element) {
						return;
					} else {
						onClick(e);
					}
				}}
				style={{
					...activatorStyle,
				}}
				disabled={disabled}
				customWidth={customWidth}
				isOpen={isOpen}
				isPhone={isPhone}
				layerSide={layerSide}
				withCaret={withCaret}
				customCaretMargin={customCaretMargin}
				rowGap="1px"
				customPadding={"0.5rem 1rem 5px 1rem;"}
			>
				<Block>
					<StyledText
						allowTranslate={!isMultiple}
						bold={
							(isSelected && !noBold) ||
							(boldOnEmpty && !isSelected)
						}
						color={
							isSelected || (boldOnEmpty && !isSelected)
								? isLanding
									? "blackAlways"
									: "black"
								: isLanding
								? "greyAlways"
								: "grey"
						}
					>
						{typeof displayContent === "string" && displayContent}
						{typeof displayContent === "number" && displayContent}
						{typeof displayContent === "function" &&
							displayContent()}
						{selectedLimit && Array.isArray(displayContent)
							? displayContent.length <= selectedLimit
								? displayContent.map((item, index) => (
										<Fragment key={index}>
											{item}
											{index + 1 <
												displayContent.length && ", "}
										</Fragment>
								  ))
								: selectedLimitText
							: Array.isArray(displayContent) &&
							  displayContent.map((item, index) => (
									<Fragment key={index}>
										{item}
										{index + 1 < displayContent.length &&
											", "}
									</Fragment>
							  ))}
					</StyledText>
				</Block>
			</Selector.Section>
		</Selector>
	);
};

export default Activator;

// #####################################################
